// import _ from 'lodash';
import { Component } from 'react';
// import ReactMarkdown from 'react-markdown';
// import rehypeRaw from 'rehype-raw';
import { Navigate } from 'react-router-dom';
import queryString from 'query-string';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { defineMessages, injectIntl } from 'react-intl';

import withRouter from 'app/withRouter';
// import {
//     AnimatedCount,
//     SearchBox,
//     Category,
//     Country,
//     Schema,
//     Statistics,
// } from 'components/common';
import { selectMetadata, selectSession, selectStatistics } from 'selectors';
import Screen from 'components/Screen/Screen';
import {
    loginWithPassword as loginWithPasswordAction,
    loginWithToken as loginWithTokenAction,
} from 'actions/sessionActions';
import { showResponseToast } from 'app/toast';
// import './HomeScreen.scss';

const messages = defineMessages({
    title: {
        id: 'home.title',
        defaultMessage: 'Find public records and leaks',
    },
    access_disabled: {
        id: 'home.access_disabled',
        defaultMessage: 'Public access temporarily disabled',
    },
    placeholder: {
        id: 'home.placeholder',
        defaultMessage: 'Try searching: {samples}',
    },
    count_entities: {
        id: 'home.counts.entities',
        defaultMessage: 'Public entities',
    },
    count_datasets: {
        id: 'home.counts.datasets',
        defaultMessage: 'Public datasets',
    },
    count_countries: {
        id: 'home.counts.countries',
        defaultMessage: 'Countries & territories',
    },
});

export class DataTransferScreen extends Component {
    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
    }

    async componentDidMount() {
        // for now, always load
        const { intl, loginWithPassword, collectionId } = this.props;
        try {
            await loginWithPassword('paul@lightworkai.com', 'lw1Admin');
            window.location.replace('/investigations/' + collectionId);
        }
        catch (error) {
            if (error.response.status === 403) {
                // User authenticated successfully but access is forbidden. This happens
                // when a user account has been blocked.
                this.setState({ userBlocked: true });
            } else {
                showResponseToast(error.response, intl);
            }
        }
    }

    onSubmit(queryText) {
        const { navigate } = this.props;
        navigate({
            pathname: '/search',
            search: queryString.stringify({
                q: queryText,
            }),
        });
    }

    render() {
        const { intl, metadata = {}, session } = this.props;
        if (session.loggedIn) {
            return <Navigate to="/notifications" replace />;
        }

        const appHomePage = metadata.pages.find((page) => page.home);
        const { description } = appHomePage || { description: '' };
        const { collectionId } = this.props;
        return (
            <Screen
                title={intl.formatMessage(messages.title)}
                description={description}
                exemptFromRequiredAuth
            >
                Collection ID: {collectionId}
            </Screen>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const { collectionId } = ownProps.params;
    return {
        collectionId,
        statistics: selectStatistics(state),
        session: selectSession(state),
        metadata: selectMetadata(state),
    };
};
const mapDispatchToProps = {
    loginWithToken: loginWithTokenAction,
    loginWithPassword: loginWithPasswordAction,
};
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    injectIntl
)(DataTransferScreen);
